import * as React from 'react';
import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Badge from './Badge';
import Chevron from './Chevron';
import Translate, { translate } from './Translate';
import FilterSearch from './FilterSearch';
import FilterValue from './FilterValue';
import { FilterStore } from '../stores';
import { FilterSearchKeys } from '../stores/FilterStore';

const FilterPropertyHeader = styled<any, any>('h4')`
    ${propStyles};
    cursor: pointer;
`;

FilterPropertyHeader.defaultProps = {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontFamily: "heading",
    fontWeight: "medium",
    color: "body"
};

const FilterListWrapper = styled<any, any>('div')`
    ${propStyles};
`;

FilterListWrapper.defaultProps = {
    paddingX: "lg",
    paddingY: "md",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: ["none none solid none", "none none solid none", "none"]
};

const FilterList = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

FilterList.defaultProps = {
    maxHeight: "300px",
    overflowX: "hidden",
    overflowY: "auto",
};

const Divider = styled<any, any>('hr')`
    ${propStyles};
` as any; // TODO: why?!

Divider.defaultProps = {
    borderWidth: "1px",
    borderColor: "gray500",
    borderStyle: "dotted none none none"
};

type Filter = {
    type: 'CLSS' | 'DOCUMENT_META' | 'DOCUMENT_PROPERTY';
    property: string;
    label: string;
    values: Array<FilterValue>;
    ui?: string;
    expanded?: boolean;
    enableSearch?: boolean;
    filterSearchKey: FilterSearchKeys;
};

type FilterValue = {
    label: string;
    value: string;
};

interface FilterItemProps {
    theme?: { [property: string]: string | number };
    translations?: { [property: string]: string };
    filterStore?: FilterStore;
    filter: Filter;
    expanded: boolean;
    toggleExpanded: Function;
    selectedCount: number;
    total: number; 
    search: string;
    clearSearch: Function;
    selectedValues: Array<FilterValue>;
    filteredValues: Array<FilterValue>;
    filterSearch: Function; 
    enableSearch: boolean;
    filterDropdownText: string;
}

@inject('translations')
@inject('filterStore')
@observer
class FilterItem extends Component<FilterItemProps> {
    render() {
        const { 
            theme, 
            translations, 
            filterStore, 
            filter,

            // withFilter HoC props
            expanded,
            toggleExpanded, 
            selectedCount, 
            total, 
            search, 
            clearSearch, 
            selectedValues, 
            filteredValues,
            filterSearch, 
            enableSearch 
        } = this.props;

        return (
            <FilterListWrapper>
                <FilterPropertyHeader
                    onClick={toggleExpanded}
                    {...theme.FilterPropertyHeader}
                >
                    <Chevron
                        direction={expanded ? 'down' : 'right'}
                        margin="0 0 0 -12px"
                    />
                    <Translate>{filter.label}</Translate>
                    {selectedCount > 0 &&
                        <Badge
                            margin="0 0 0 auto"
                            data-selected={selectedCount > 0}
                            selected={{
                                bgColor: "primary"
                            }}
                            {...theme.FilterTotalBadge}
                        >
                            {selectedCount}/{total}
                        </Badge>
                    }
                </FilterPropertyHeader>
                {
                    expanded && (
                        <Fragment>
                            {
                                enableSearch && (
                                    <FilterSearch
                                        type="text"
                                        placeholder={
                                            `${translate(translations, "Search")} ${translate(translations, filter.label)}`}
                                        value={search}
                                        onChange={e => filterSearch(e.target.value)}
                                        onClear={clearSearch}
                                        showClear={search.length > 0}
                                    />
                                )
                            }
                            <FilterList
                                {...theme.SelectedFilterList}
                            >
                                {
                                    selectedValues.map((value, valueIndex) =>
                                        <FilterValue
                                            key={`${value.label}-${valueIndex}`}
                                            label={value.label}
                                            checked={true}
                                            onChange={(e) => filterStore.toggleFilter(filter.property, value.value, filter.filterSearchKey, true)}
                                            active={true}
                                            {...theme.SelectedFilterListItem}
                                        />
                                    )
                                }
                            </FilterList>
                            {
                                (selectedValues.length > 0 && filteredValues.length > 0) &&
                                <Divider 
                                    {...theme.FilterListDivider} 
                                />
                            }
                            <FilterList
                                {...theme.FilterList}
                            >
                                {
                                    filteredValues.map((value, valueIndex) =>
                                        <FilterValue
                                            key={`${value.label}-${valueIndex}`}
                                            label={value.label}
                                            checked={false}
                                            onChange={(e) => filterStore.toggleFilter(filter.property, value.value, filter.filterSearchKey, false)}
                                            active={filterStore.isActive(filter.property, value.value)}
                                            {...theme.FilterListItem}
                                        />
                                    )
                                }
                            </FilterList>
                        </Fragment>
                    )
                }
            </FilterListWrapper>
        );
    }
}

export default withTheme(FilterItem);


// WEBPACK FOOTER //
// ./src/Components/FilterItem.tsx